<template>
  <div class="h-96 bg-white rounded-md overflow-hidden">
    <div class="px-4 py-3 text-grey border-b border-grey-blue">
      {{ title }}
    </div>
    <div class="px-4 py-3" style="height: calc(100% - 54px)">
      <div
        v-if="IS_LOADING"
        class="flex flex-col justify-center items-center w-full h-full"
      >
        <loading-spinner />
        <p class="mt-2">Die Daten werden geladen...</p>
      </div>
      <slot v-else></slot>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent } from "vue";
import { useStore } from "vuex";
import { HELPER_TYPES, STORE_TYPES } from "../../store/types";
import LoadingSpinner from "./LoadingSpinner.vue";

export default defineComponent({
  components: { LoadingSpinner },
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const IS_LOADING = computed(() => {
      const loadingIds =
        store.getters[`${STORE_TYPES.HELPERS}/${HELPER_TYPES.GET_LOADING_IDS}`];
      let isLoading = loadingIds.find((loadingId) => {
        return loadingId == props.id;
      });
      if (isLoading) {
        return true;
      }
      return false;
    });
    return { IS_LOADING };
  },
});
</script>
